// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"f85ccc58","488":"4363d96a","559":"2c38d4a8","640":"6357040c"}[chunkId] + ".chunk.js";
};